var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigninWithFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Facebook_f_logo_(2019)",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 239",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(0 1)",
    fill: "#1977f3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M13.898 13.891L14.34 11h-2.773V9.124a1.446 1.446 0 011.63-1.562h1.261V5.105a15.372 15.372 0 00-2.239-.2 3.529 3.529 0 00-3.777 3.891v2.2H5.898v2.891h2.54v6.988a10.055 10.055 0 001.563.121 10.229 10.229 0 001.563-.121v-6.988z",
    fill: "#fff"
  }))));
}
export default SvgSigninWithFacebook;